import { Component, OnInit, ViewContainerRef, ViewChild, Input, ComponentFactoryResolver, Output, EventEmitter } from '@angular/core';
import { StepTemplateBaseComponent } from 'app/core/components/dynamic-onboarding/step-template-base/step-template-base.component';
import { EmployeesCardComponent } from '../employees-card/employees-card.component';
import { GdprCardComponent } from '../gdpr-card/gdpr-card.component';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { RxComponent } from '../../common/rx.component';
import { ChildState } from 'app/core/components/dynamic-onboarding/dynamic-onboarding.component';
// import { ConfigService } from 'app/core/services/config.service';
import { OverviewCardComponent } from '../overview-card/overview-card.component';
import { BrandingCardComponent } from 'app/core/components/dynamic-onboarding/branding-card/branding-card.component';
import { DynamicOnboardingConfigurationService } from '../dynamic-onboarding-configuration.service';
import { StepState } from 'app/shared/components/happy/happy-stepper/happy-stepper.component';
import { InstructionsComponent } from 'app/core/components/dynamic-onboarding/instructions/instructions.component';

@Component({
  selector: 'itpx-onboarding-item',
  templateUrl: './onboarding-item.component.html',
  styleUrls: ['./onboarding-item.component.css']
})
export class OnboardingItemComponent extends RxComponent {

  @Input() data: {cardType: string, image?: string, text?: string, folds: number};
  @Input() next: Observable<string>;
  @Input() parentForm: FormGroup;
  @Input() stepState$: Observable<StepState>;
  @Output() status = new EventEmitter<ChildState>();
  @Output() message = new EventEmitter<{label: string, text: string}>();
  // @ViewChild('right', {read: ViewContainerRef}) private right: ViewContainerRef;
  @ViewChild('container', {read: ViewContainerRef}) private container: ViewContainerRef;
  // @ViewChild('middle', {read: ViewContainerRef}) private middle: ViewContainerRef;

  getComponentMapping() {
    return {
      gdpr: GdprCardComponent,
      employees: EmployeesCardComponent,
      overview: OverviewCardComponent,
      branding: BrandingCardComponent,
      adminInduction: InstructionsComponent,
      adminInduction2: InstructionsComponent,
      adminInduction3: InstructionsComponent,
      adminInduction4: InstructionsComponent,
      welcome: InstructionsComponent,
      deliveryManagerInduction: InstructionsComponent,
      deliveryManagerInduction2: InstructionsComponent,
      deliveryManagerInduction3: InstructionsComponent,
      deliveryManagerInduction4: InstructionsComponent,
      buyerInduction: InstructionsComponent,
      buyerInduction2: InstructionsComponent,
      buyerInduction3: InstructionsComponent,
      buyerInduction4: InstructionsComponent,
      buyerInduction5: InstructionsComponent,
      deliveryManagerbuyerInduction: InstructionsComponent,
      deliveryManagerbuyerInduction2: InstructionsComponent,
      deliveryManagerbuyerInduction3: InstructionsComponent,
      deliveryManagerbuyerInduction4: InstructionsComponent,
      deliveryManagerbuyerInduction5: InstructionsComponent
    };
  }

  readonly templateMapper = this.getComponentMapping();

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    // private configService: ConfigService,
    private dynamicConfService: DynamicOnboardingConfigurationService
  ) {
    super();
  }

  ngAfterViewInit() {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.getComponentForCardType(this.data.cardType));
    const viewContainerRef = this.container;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<StepTemplateBaseComponent>componentRef.instance).id = this.data.cardType;
    (<StepTemplateBaseComponent>componentRef.instance).next = this.next;
    (<StepTemplateBaseComponent>componentRef.instance).parentForm = this.parentForm;
    (<StepTemplateBaseComponent>componentRef.instance).status.bindToLifecycle(this).subscribe(val => this.status.emit(val));
    (<StepTemplateBaseComponent>componentRef.instance).message.bindToLifecycle(this).subscribe(val => this.message.emit(val));
    (<StepTemplateBaseComponent>componentRef.instance).stepState$ = this.stepState$;
  }
  private getComponentForCardType(cardType) {
    return this.templateMapper[cardType];
  }

    imageLoaded(img){
        let imageDiv = img.parentElement;
        let cellDiv = imageDiv.parentElement;

        if(cellDiv.clientWidth > img.width && cellDiv.clientHeight > img.height)
            imageDiv.style.backgroundSize = 'auto';
        else
            imageDiv.style.backgroundSize = 'contain';
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/dynamic-onboarding/onboarding-item/onboarding-item.component.ts